export type LoginVariant = "branch" | "admin" | "company";

export const inputClass = (variant: LoginVariant = "branch") =>
  [
    "login-input",
    variant === "admin" ? "login-input-admin" : "",
    variant === "company" ? "login-input-company" : "",
  ]
    .filter(Boolean)
    .join(" ");

export const submitClass = (variant: LoginVariant = "branch") =>
  [
    "login-submit",
    variant === "admin" ? "login-submit-admin" : "",
    variant === "company" ? "login-submit-company" : "",
  ]
    .filter(Boolean)
    .join(" ");

export const linkClass = (variant: LoginVariant = "branch") =>
  [
    "login-link",
    variant === "admin" ? "login-link-admin" : "",
    variant === "company" ? "login-link-company" : "",
  ]
    .filter(Boolean)
    .join(" ");

export const visualBgClass: Record<LoginVariant, string> = {
  branch:
    "bg-[linear-gradient(160deg,rgba(11,28,44,0.2),transparent_45%),linear-gradient(25deg,#0b1c2c_0%,#123048_55%,#0f2a40_100%)]",
  admin:
    "bg-[linear-gradient(160deg,rgba(28,20,16,0.15),transparent_45%),linear-gradient(25deg,#1c1410_0%,#2c2118_55%,#201812_100%)]",
  company:
    "bg-[linear-gradient(160deg,rgba(16,24,32,0.15),transparent_45%),linear-gradient(25deg,#101820_0%,#1a2836_55%,#152230_100%)]",
};

export const slashAccentClass: Record<LoginVariant, string> = {
  branch: "bg-[#c9a24d]",
  admin: "bg-[#c56a3d]",
  company: "bg-[#5a8fd4]",
};
